import { useDeadlineCountdown } from './useDeadlineCountdown';
import { shouldShowCountdown } from '../utils/offerAvailabilityDisplay';

/**
 * FIN-8011: tempo restante da oferta que a tela deve mostrar, ou `null` para
 * esconder (sem prazo, prazo zerado ou acima do limiar de urgência, D17).
 * Chamado uma vez por tela: a faixa do topo e o card do resumo recebem o
 * mesmo valor, então batem juntos e somem juntos.
 * `isExpired` é true quando o prazo zerou (distinto de "escondido pelo
 * limiar"): as vagas restantes dependem dele (FIN-8119 R14).
 */
export function useOfferCountdown({
  availableUntil,
  urgencyTimeThresholdMinutes,
}: {
  availableUntil?: string | null;
  /** Minutos antes do fim para mostrar o contador; null = sempre. */
  urgencyTimeThresholdMinutes?: number | null;
}): { remainingMs: number | null; isExpired: boolean } {
  const { remainingMs } = useDeadlineCountdown(availableUntil);

  const isVisible = shouldShowCountdown(
    remainingMs,
    urgencyTimeThresholdMinutes
  );

  return {
    remainingMs: isVisible ? remainingMs : null,
    isExpired: remainingMs === 0,
  };
}
